<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <KnowledgeCheckDetailWrap />
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import KnowledgeCheckDetailWrap from '@/components/view_blocks/Knowledge_check_detail/Knowledge_check_detail_wrap.vue';

export default {
  components: {
    KnowledgeCheckDetailWrap,
    HeaderMenu,
    UserMenu,
    FooterBlock,
  },
};
</script>
